import "@Styles/Pages/Print/print_sm.less";
import printHeader from '../../Controls/Print/printHeader';
import printImageToggle from '../../Controls/Print/printImageToggle';
import printRecipeDrawer from '../../Controls/Print/printRecipeDrawer';

(function () {
  GeneralMills.PandoSites.RegisterModules({
    printHeader: printHeader,
    printImageToggle: printImageToggle,
    recipeDrawer: printRecipeDrawer,
    recipeStepShots: function recipeStepShots() {} // mock out step shots so that lazy loaded images do not appear 

  });
})();